import { Component, OnInit, Inject } from '@angular/core';
import { EFormControl } from '../../../../shared-components/e-forms/e-form-control.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-e-form-row-column-location',
    templateUrl: './e-form-row-column-location.html'
})

export class EFormRrowColumnLocationComponent implements OnInit {

    objects: EFormControl[];
    selectedObject: EFormControl;
    location: string;
    headerLabel: string;
    cotrolType: string;
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<EFormRrowColumnLocationComponent>
    ) { }

    ngOnInit() {
        if(this.cotrolType == 'row'){
            this.location = 'above';
        }
        else{
            this.location = 'right';
        }
    }
    SetRadioValue(value) {
        this.location = value;
    }

    cancelClick() {
        this.dialogRef.close();
    }

    saveClick() {
        if (this.location)
            this.dialogRef.close(this.location);
    }
}
